import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {InventoryAct, InventoryActSearchParams} from '@accounting/_common/models/inventory-act.models';

export const CheckState = createAction(
    '[InventoryActs] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: InventoryAct[] } }>()
);

export const CheckStateSuccess = createAction(
    '[InventoryActs] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: InventoryAct[] } }>()
);

export const LoadList = createAction(
    '[InventoryActs] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[InventoryActs] Load List Success',
    props<{ payload: { items: InventoryAct[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[InventoryActs] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[InventoryActs] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[InventoryActs] Set Filter',
    props<{ payload: InventoryActSearchParams }>()
);

export const SetLoading = createAction(
    '[InventoryActs] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[InventoryActs] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[InventoryActs] Update Item Success',
    props<{ payload: InventoryAct }>()
);

export const DeleteItem = createAction(
    '[InventoryActs] Delete Item',
    props<{ payload: InventoryAct }>()
);

export const DeleteItemSuccess = createAction(
    '[InventoryActs] Delete Item Success',
    props<{ payload: InventoryAct }>()
);

export const DeleteItemFailure = createAction(
    '[InventoryActs] Delete Item Failure',
    props<{ payload: InventoryAct }>()
);

export const SetInitialState = createAction(
    '[InventoryActs] Set Initial State'
);
